import React, { useContext, useState } from 'react';
import PlayerStatus from './PlayerStatus';
import { useNavigate, useParams } from 'react-router-dom';
import { GameContext } from '../GameContext';
import ShareCodeButton from '../share/ShareCodeButton';
import { getReadyPlayers, addReadyPlayersToDB } from '../utils/dbUtils';
import { selectPrompt, getThinkersNames, getOrderOfNames, getOrderOfPrompts } from '../utils/gameUtils';
import * as amplitude from '@amplitude/analytics-browser';
import QRCodeButton from '../share/QRCodeButton';
import CropFreeIcon from '@mui/icons-material/CropFree';
import { CreativeTVLink } from '../CreativeDisplayBridge';

const WaitingLobbyCard = () => {
    const [starting, setStarting] = useState(false);
    const [error, setError] = useState('');
    const [editingPicture, setEditingPicture] = useState(false);

    const {
        players,
        setCurrentCardNumber,
    } = useContext(GameContext);
    const navigate = useNavigate();
    const { urlGameCode } = useParams();

    const readyPlayersCount = players.filter(player => player.isReady).length;
    const isStartButtonEnabled = readyPlayersCount >= 4;

    // WaitingLobbyCard.js

    const handleStartClick = async () => {
        amplitude.track('Start Creative Mode');

        if (isStartButtonEnabled && !starting) {
          setStarting(true); setError('');
          try {
            const readyPlayers = await getReadyPlayers(urlGameCode);
            await addReadyPlayersToDB(urlGameCode, readyPlayers);
            const orderOfNamesObj = getOrderOfNames(readyPlayers);
            const orderOfPrompts = getOrderOfPrompts(
                readyPlayers,
                orderOfNamesObj,
            );
            const data = {
                ...JSON.parse(localStorage.getItem(urlGameCode + '_data')),
                currentCardNumber: 1,
                currentPlayerIndex: 0,
                currentGuesserIndex: 0,
                orderOfNames: orderOfNamesObj,
                orderOfPrompts: orderOfPrompts,
                readyPlayers: readyPlayers,
                currentCardType: 'prompt',
                scoreHistory: [],
                completed: false,
                revealedTurn: '',
            };
            localStorage.setItem(urlGameCode + '_data', JSON.stringify(data));

            // must keep in seperate udpate since the methods depend on the previous data being saved locally first
            const updateData = {
                ...JSON.parse(localStorage.getItem(urlGameCode + '_data')),
                currentPlayerNames: getThinkersNames(urlGameCode),
                currentPrompt: selectPrompt(urlGameCode),
            }
            localStorage.setItem(urlGameCode + '_data', JSON.stringify(updateData));
            
            setCurrentCardNumber(1); // not sure if this context variable is needed any more in creative mode; maybe needed in simple mode

            navigate(`/creative-mode/${urlGameCode}/play`);
          } catch (e) {
            setError('Couldn’t start the round. Please check your connection and try again.');
          } finally { setStarting(false); }
        }

    }

    return <section className="creative-lobby-card">
      <CreativeTVLink code={urlGameCode} />
      <div className="creative-lobby-heading"><div><h1>Your table.</h1><p>{readyPlayersCount} ready to play</p></div><div className="creative-room-code"><div><ShareCodeButton code={urlGameCode} /><QRCodeButton code={urlGameCode} buttonIcon={<CropFreeIcon sx={{ minWidth: 0 }} />} /></div><strong>{urlGameCode}</strong></div></div>
      <PlayerStatus onEditingChange={setEditingPicture} />
      <div className="creative-lobby-start"><button className="button dark full" onClick={handleStartClick} disabled={!isStartButtonEnabled || starting || editingPicture}>{starting ? 'Dealing…' : 'Start the round'}</button>
      {error && <p role="alert" className="error-message">{error}</p>}
      {!isStartButtonEnabled && <p>At least 4 players need to be ready.</p>}</div>
    </section>;
};

export default WaitingLobbyCard;
